import { ProjectParameters } from 'ducks/types/store-types';
import { UnionFromArray } from 'ducks/types/type-helpers';
import { v4 as uuidv4 } from 'uuid';

export const default_input_parameter: ProjectParameters[number] = {
  owner_id: null,
  reference_type_name: '',
  reference_name: '',
  parameter_name: '',
  description: '',
  parameter_method_id: 1,
  parameter_method_name: 'Command Line',
  parameter_direction_id: 1,
  parameter_direction_name: 'Input',
  parameter_value: '',
  is_required: true,
  command_line_assignment_char: '=',
  command_line_escaped: true,
  command_line_ignore_name: false,
  command_line_prefix: '--',
  is_encrypted: false,
  reference_type_id: null,
  reference_id: null,
  reference_parameter_name: '',
  modified: false,
  saved: false,
  delete: false,
  parameter_value_disabled: false,
  uuid: uuidv4(),
};

export const input_headers = [
  {
    name: '',
    width: '40px',
    resize: false,
    uuid: 1,
  },
  {
    name: 'Parameter',
    width: '250px',
    uuid: 2,
  },
  {
    name: 'Value',
    width: '200px',
    flex_grow: 1,
    uuid: 3,
  },
  {
    name: 'Description',
    width: '250px',
    uuid: 4,
  },
  {
    name: 'Method',
    width: '80px',
    uuid: 6,
  },
  {
    width: '34px',
    horizontal_cell_align: 'center',
    vertical_cell_align: 'center',
    resize: false,
    uuid: 7,
  },
];

export const refresh_time_map = {
  '1m': 60000,
  '5m': 300000,
  '10m': 600000,
  '30m': 1800000,
  '1h': 3600000,
};

export const refresh_time_array = [
  {
    time: 60000,
    name: '1m',
    id: 2,
    uuid: uuidv4(),
  },
  {
    time: 300000,
    name: '5m',
    id: 3,
    uuid: uuidv4(),
  },
  {
    time: 600000,
    name: '10m',
    id: 4,
    uuid: uuidv4(),
  },
  {
    time: 1800000,
    name: '30m',
    id: 5,
    uuid: uuidv4(),
  },
  {
    time: 3600000,
    name: '1h',
    id: 6,
    uuid: uuidv4(),
  },
];

export type RefreshTimeArrayItem = UnionFromArray<typeof refresh_time_array>;
